import { navigateTo, useRoute } from '#imports'
import { type Ref, computed } from 'vue'

import type { NavigateToOptions } from '#app/composables/router'

export type UseRouterStep = () => {
  step: Ref<number>
  goToStep: (step: number, external?: NavigateToOptions) => void
}

export const useRouterStep: UseRouterStep = () => {
  const route = useRoute()

  const step = computed(() => {
    const routeStep = route.query.step?.toString() || ''

    return Math.max(Number.parseInt(routeStep, 10) || 0, 0)
  })

  const goToStep = async (newStep: number, options?: NavigateToOptions) =>
    await navigateTo(
      {
        query: {
          ...route.query,
          step: newStep,
        },
      },
      {
        ...(options || {}),
      },
    )

  return { step, goToStep }
}
